import React, { useState, useEffect, useCallback } from "react";
import AgruparModal from "../dashboard/components/AgruparModal";
import api from "../../core/api/config";
import { Modal } from "bootstrap";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Select from "react-select";
import { formatDate } from "../../shared/utils/formatDate";
import { capitalizarTexto } from "../../shared/utils/formatador";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import EditRastreamento from "../rastreamento/editrastreamento";

const UnificacaoCadastros = () => {
  const perfilAtivo = useSelector((state) => state.access.perfilAtivo);
  const location = useLocation();
  const pacienteId = location.state?.pacienteId;
  const pacienteNome = location.state?.pacienteNome;

  const usuarioLogadoId = perfilAtivo?.id;
  const cidadeUsuario = perfilAtivo?.cidade_id;

  const [filtros, setFiltros] = useState({
    id: "",
    nomeCpfCns: "",
    dataNascimento: null,
    nomeMae: "",
    codigoCidade: null,
  });

  const [pacientes, setPacientes] = useState([]);
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  const [selecionados, setSelecionados] = useState([]);
  const [principal, setPrincipal] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cidades, setCidades] = useState([]);
  const [cidadeSelecionada, setCidadeSelecionada] = useState(null);

  // Estados para o modal de CNES + Organograma
  const [showCnesModal, setShowCnesModal] = useState(false);
  const [comboOptions, setComboOptions] = useState([]);
  const [selectedCombo, setSelectedCombo] = useState(null);
  const [loadingCombo, setLoadingCombo] = useState(false);
  const [pendingUnification, setPendingUnification] = useState(null);

  // Estado para controlar o accordion de pessoas unificadas
  const [accordionAberto, setAccordionAberto] = useState({});
  const [pessoasUnificadas, setPessoasUnificadas] = useState({});
  const [loadingUnificadas, setLoadingUnificadas] = useState({});

  // Estado para controlar seleção de pessoas para desunificar
  const [pessoasParaDesunificar, setPessoasParaDesunificar] = useState({});
  const [motivoReversao, setMotivoReversao] = useState("");
  const [showMotivoModal, setShowMotivoModal] = useState(false);
  const [pessoaPrincipalDesunificacao, setPessoaPrincipalDesunificacao] =
    useState(null);

  const abrirVisualizacao = (paciente) => {
    setPacienteSelecionado(paciente);

    const modalElement = document.getElementById("edit-rastreamento");

    if (!modalElement) return;

    Modal.getOrCreateInstance(modalElement).show();
  };
  
  useEffect(() => {
    if (cidadeUsuario && cidades.length > 0) {
      const cidade = cidades.find(
        (c) => Number(c.value) === Number(cidadeUsuario),
      );

      if (cidade) {
        setCidadeSelecionada(cidade);
        setFiltros((prev) => ({
          ...prev,
          codigoCidade: Number(cidade.value),
        }));
      }
    }
  }, [cidades, perfilAtivo, cidadeUsuario]);

    //
  // BUSCAR CIDADÃO
  //
  const buscarCidadao = useCallback(
    async (filtrosBusca = filtros) => {
      try {
        setLoading(true);

        const response = await api.post(
          "/api/tracking/api/pessoas/buscar-cidadao",
          {
            nomeCpfCns: filtrosBusca.nomeCpfCns || null,
            codigoPessoa: filtrosBusca.id || null,
            dataNascimento: filtrosBusca.dataNascimento || null,
            nomeMae: filtrosBusca.nomeMae || null,
            codigoCidade: filtrosBusca.codigoCidade || null,
          },
        );

        setPacientes(response.data);
        setSelecionados([]);
        setPrincipal(null);
        setAccordionAberto({});
        setPessoasUnificadas({});
        setPessoasParaDesunificar({});
      } catch (error) {
        console.error("Erro ao buscar cidadão", error);
      } finally {
        setLoading(false);
      }
    },
    [
      filtros,
      setLoading,
      setPacientes,
      setSelecionados,
      setPrincipal,
      setAccordionAberto,
      setPessoasUnificadas,
      setPessoasParaDesunificar,
    ],
  );

  const limparBusca = () => {
    setFiltros({
      nomeCpfCns: "",
      dataNascimento: null,
      nomeMae: "",
      codigoCidade: null,
      id: "",
    });

    setCidadeSelecionada(null);
    setPacientes([]);
    setSelecionados([]);
    setPrincipal(null);
    setAccordionAberto({});
    setPessoasUnificadas({});
    setPessoasParaDesunificar({});
  };

  useEffect(() => {
    if ((pacienteNome || pacienteId) && cidadeUsuario) {
      const novosFiltros = {
        id: pacienteId || "",
        nomeCpfCns: pacienteNome || "",
        dataNascimento: null,
        nomeMae: "",
        codigoCidade: cidadeUsuario,
      };

      setFiltros(novosFiltros);
      buscarCidadao(novosFiltros);
    }
  }, [pacienteId, pacienteNome, cidadeUsuario, buscarCidadao]);

  useEffect(() => {
    if (pacienteId && pacientes.length > 0) {
      const pacienteEncontrado = pacientes.find((p) => p.id === pacienteId);

      if (pacienteEncontrado) {
        setSelecionados([pacienteId]);
        setPrincipal(pacienteId);
      }
    }
  }, [pacientes, pacienteId]);

  // ===============================
  // EXTRAIR CNES E ORGANOGRAMAS DOS PACIENTES SELECIONADOS
  // ===============================
  const extrairComboOpcoes = (pacientesSelecionados) => {
    const comboMap = new Map();

    pacientesSelecionados.forEach((paciente) => {
      if (
        paciente.cnesId &&
        paciente.cnes &&
        paciente.idOrganograma &&
        paciente.unidadeResponsavel
      ) {
        const key = `${paciente.cnesId}_${paciente.idOrganograma}`;
        if (!comboMap.has(key)) {
          comboMap.set(key, {
            value: {
              cnesId: paciente.cnesId,
              organogramaId: paciente.idOrganograma,
            },
            label: `${paciente.cnes} - ${paciente.unidadeResponsavel}`,
            cnesId: paciente.cnesId,
            cnesNome: paciente.cnes,
            organogramaId: paciente.idOrganograma,
            organogramaNome: paciente.unidadeResponsavel,
          });
        }
      }
    });

    return Array.from(comboMap.values());
  };

  // ===============================
  // BUSCAR ORGANOGRAMAS POR CNES PARA COMBINAR
  // ===============================
  const buscarCombinacoesOrganogramas = async (cnesId, cnesNome) => {
    try {
      setLoadingCombo(true);

      // Busca organogramas do backend
      const response = await api.get(
        `/api/organograma/listar-por-cnes/${cnesId}`,
      );

      const combinacoes = [];

      if (response.data && response.data.length > 0) {
        response.data.forEach((org) => {
          combinacoes.push({
            value: {
              cnesId: cnesId,
              organogramaId: org.id,
            },
            label: `${cnesNome} - ${org.nome}`,
            cnesId: cnesId,
            cnesNome: cnesNome,
            organogramaId: org.id,
            organogramaNome: org.nome,
          });
        });
      }

      return combinacoes;
    } catch (error) {
      console.error("Erro ao buscar organogramas:", error);
      return [];
    } finally {
      setLoadingCombo(false);
    }
  };

  // ===============================
  // BUSCAR PESSOAS UNIFICADAS
  // ===============================
  const buscarPessoasUnificadas = async (pessoaPrincipalId) => {
    if (loadingUnificadas[pessoaPrincipalId]) return;

    try {
      setLoadingUnificadas((prev) => ({ ...prev, [pessoaPrincipalId]: true }));

      const response = await api.get(
        `/api/tracking/api/pessoas/${pessoaPrincipalId}/unificadas`,
      );

      const unificadas = response.data.map((item) => ({
        unificacaoId: item.unificacaoId,
        pessoaId: item.pessoaId,
        nome: item.nome,
        cpf: item.cpf,
        cns: item.cns,
        dataNascimento: item.dataNascimento,
        sexo: item.sexo,
        nomeMae: item.nomeMae,
        unidadeResponsavel: item.unidadeResponsavel,
        idOrganograma: item.idOrganograma,
        cnesId: item.cnesId,
        cnes: item.cnes,
        endereco: item.endereco,
        unificadaEm: item.unificadaEm,
      }));

      setPessoasUnificadas((prev) => ({
        ...prev,
        [pessoaPrincipalId]: unificadas || [],
      }));

      setPessoasParaDesunificar((prev) => ({
        ...prev,
        [pessoaPrincipalId]: [],
      }));
    } catch (error) {
      console.error("Erro ao buscar pessoas unificadas", error);
      setPessoasUnificadas((prev) => ({
        ...prev,
        [pessoaPrincipalId]: [],
      }));
    } finally {
      setLoadingUnificadas((prev) => ({ ...prev, [pessoaPrincipalId]: false }));
    }
  };

  // ===============================
  // DESUNIFICAR
  // ===============================
  const toggleSelecionadoDesunificar = (pessoaPrincipalId, pessoaId) => {
    setPessoasParaDesunificar((prev) => {
      const selecionadosAtuais = prev[pessoaPrincipalId] || [];

      if (selecionadosAtuais.includes(pessoaId)) {
        return {
          ...prev,
          [pessoaPrincipalId]: selecionadosAtuais.filter(
            (id) => id !== pessoaId,
          ),
        };
      } else {
        return {
          ...prev,
          [pessoaPrincipalId]: [...selecionadosAtuais, pessoaId],
        };
      }
    });
  };

  const selecionarTodasDesunificar = (pessoaPrincipalId) => {
    const todasPessoas = pessoasUnificadas[pessoaPrincipalId] || [];
    const todasIds = todasPessoas.map((p) => p.pessoaId);

    setPessoasParaDesunificar((prev) => ({
      ...prev,
      [pessoaPrincipalId]: todasIds,
    }));
  };

  const limparSelecaoDesunificar = (pessoaPrincipalId) => {
    setPessoasParaDesunificar((prev) => ({
      ...prev,
      [pessoaPrincipalId]: [],
    }));
  };

  const abrirModalMotivo = (pessoaPrincipalId) => {
    const selecionados = pessoasParaDesunificar[pessoaPrincipalId] || [];

    if (selecionados.length === 0) {
      showError(
        "Nenhum registro selecionado",
        "Selecione pelo menos uma pessoa para desunificar.",
      );
      return;
    }

    setPessoaPrincipalDesunificacao(pessoaPrincipalId);
    setMotivoReversao("");
    setShowMotivoModal(true);
  };

  const desunificar = async () => {
    if (!pessoaPrincipalDesunificacao || !motivoReversao.trim()) {
      showError(
        "Motivo obrigatório",
        "Por favor, informe o motivo da desunificação.",
      );
      return;
    }

    const selecionados =
      pessoasParaDesunificar[pessoaPrincipalDesunificacao] || [];

    const nomesSelecionados =
      pessoasUnificadas[pessoaPrincipalDesunificacao]
        ?.filter((p) => selecionados.includes(p.pessoaId))
        .map((p) => p.nome) || [];

    showWarning(
      "Deseja realmente desunificar os cadastros?",
      <div style={{ textAlign: "left" }}>
        <p>
          <strong>Pessoas que serão desunificadas:</strong>
        </p>
        <ul className="mb-3">
          {nomesSelecionados.map((nome, index) => (
            <li key={index}>{capitalizarTexto(nome)}</li>
          ))}
        </ul>
        <p>
          <strong>Motivo informado:</strong> {capitalizarTexto(motivoReversao)}
        </p>
      </div>,
    ).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        showLoading(
          "Desunificando cadastros...",
          "Aguarde enquanto realizamos a desunificação.",
        );

        const payload = {
          pessoasUnificadasIds: selecionados,
          usuarioLogadoId,
          motivoReversao: motivoReversao.trim(),
        };

        const response = await api.post(
          `/api/tracking/api/pessoas/${pessoaPrincipalDesunificacao}/desunificar`,
          payload,
        );

        MySwal.close();

        await showSuccess(
          "Cadastros desunificados com sucesso!",
          <div className="text-center">
            <p>Desunificação realizada com sucesso!</p>
            <p className="text-small">
              {response.data?.pessoasDesunificadas?.length || 0} pessoa(s)
              desunificada(s)
            </p>
          </div>,
        );

        setShowMotivoModal(false);
        setMotivoReversao("");
        setPessoaPrincipalDesunificacao(null);
        await buscarPessoasUnificadas(pessoaPrincipalDesunificacao);
        buscarCidadao();
      } catch (error) {
        MySwal.close();

        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Erro ao realizar desunificação.";

        console.error("Erro na desunificação:", error.response?.data || error);
        await showError("Erro ao desunificar cadastros!", errorMessage);
      }
    });
  };

  // 
  // ALTERNAR ACCORDION
  // 
  const toggleAccordion = (pessoaId) => {
    const novoEstado = !accordionAberto[pessoaId];

    setAccordionAberto((prev) => ({
      ...prev,
      [pessoaId]: novoEstado,
    }));

    if (novoEstado && !pessoasUnificadas[pessoaId]) {
      buscarPessoasUnificadas(pessoaId);
    }
  };

  useEffect(() => {
    const fetchCidades = async () => {
      try {
        const res = await api.get("/api/cidade/list");

        const cidadeArray = Array.isArray(res.data.data)
          ? res.data.data
          : Array.isArray(res.data.data?.data)
            ? res.data.data.data
            : [];

        const options = cidadeArray.map((item) => ({
          value: item.codigo_municipio,
          label: item.municipio,
        }));

        setCidades(options);
      } catch (error) {
        console.error("Erro ao carregar cidades", error);
      }
    };

    fetchCidades();
  }, []);


  // ===============================
  // ABRIR MODAL DE CNES + ORGANOGRAMA
  // ===============================
  const abrirModalCnes = async () => {
    if (selecionados.length < 2 || !principal) return;

    const pacientesSelecionados = pacientes.filter((p) =>
      selecionados.includes(p.id),
    );

    // Primeiro, extrair combinações já existentes dos pacientes
    const combinacoesExistentes = extrairComboOpcoes(pacientesSelecionados);
    const combinarAutomaticamente =
      combinacoesExistentes.length === 1 ? combinacoesExistentes[0] : null;

    // Para cada CNES único, buscar organogramas adicionais
    const cnesUnicos = new Map();
    pacientesSelecionados.forEach((paciente) => {
      if (
        paciente.cnesId &&
        paciente.cnes &&
        !cnesUnicos.has(paciente.cnesId)
      ) {
        cnesUnicos.set(paciente.cnesId, {
          id: paciente.cnesId,
          nome: paciente.cnes,
        });
      }
    });

    setLoadingCombo(true);
    setComboOptions([]);

    // Buscar combinações adicionais para cada CNES
    const todasCombinacoes = [...combinacoesExistentes];

    for (const cnes of cnesUnicos.values()) {
      const novasCombinacoes = await buscarCombinacoesOrganogramas(
        cnes.id,
        cnes.nome,
      );

      // Adicionar apenas combinações que não existem ainda
      novasCombinacoes.forEach((nova) => {
        const existe = todasCombinacoes.some(
          (existente) =>
            existente.cnesId === nova.cnesId &&
            existente.organogramaId === nova.organogramaId,
        );
        if (!existe) {
          todasCombinacoes.push(nova);
        }
      });
    }

    if (todasCombinacoes.length === 0) {
      showError(
        "Nenhuma opção disponível",
        "Os pacientes selecionados não possuem unidade de saúde ou organograma associado.",
      );
      setLoadingCombo(false);
      return;
    }

    setComboOptions(todasCombinacoes);
    setLoadingCombo(false);

    const pendingData = {
      selecionados: [...selecionados],
      principal: principal,
      pacientesSelecionados: pacientesSelecionados,
    };

    setPendingUnification(pendingData);

    if (combinarAutomaticamente) {
      setSelectedCombo(combinarAutomaticamente);
      await finalizarUnificacaoComCnes(combinarAutomaticamente, pendingData);
      return;
    }

    setSelectedCombo(null);
    setShowCnesModal(true);
  };

  // 
  // EXECUTAR UNIFICAÇÃO COM CNES + ORGANOGRAMA
  //
  const finalizarUnificacaoComCnes = async (
    comboSelecionado,
    dadosPendentes,
  ) => {
    if (!comboSelecionado) {
      showError(
        "Seleção incompleta",
        "Por favor, selecione a unidade de saúde com o organograma.",
      );
      return;
    }

    if (!dadosPendentes) return;

    const nomesSelecionados = dadosPendentes.pacientesSelecionados.map(
      (p) => p.nome,
    );
    const pacientePrincipal = dadosPendentes.pacientesSelecionados.find(
      (p) => p.id === dadosPendentes.principal,
    );

    showWarning(
      "Deseja realmente unificar os cadastros?",
      <div style={{ textAlign: "left" }}>
        <p>
          <strong>Cadastro principal:</strong>
        </p>
        <p>{capitalizarTexto(pacientePrincipal?.nome)}</p>
        <hr />
        <p>
          <strong>Cadastros que serão unificados:</strong>
        </p>
        <ul>
          {nomesSelecionados.map((nome, index) => (
            <li key={index}>{capitalizarTexto(nome)}</li>
          ))}
        </ul>
        <hr />
        <p>
          <strong>UBS Responsável selecionada:</strong>
        </p>
        <p>{capitalizarTexto(comboSelecionado.label)}</p>
      </div>,
    ).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        showLoading(
          "Unificando cadastros...",
          "Aguarde enquanto realizamos a unificação.",
        );

        const payload = {
          usuarioLogadoId: usuarioLogadoId,
          idOrganogramaPermanencia: comboSelecionado.organogramaId,
          cnesIdPermanencia: comboSelecionado.cnesId,
          pessoas: dadosPendentes.selecionados.map((id) => ({
            pessoaId: id,
            principal: id === dadosPendentes.principal,
          })),
        };

        await api.post("/api/tracking/api/pessoas", payload);

        MySwal.close();

        await showSuccess(
          <div className="text-center">
            <p style={{ fontSize: "16px", marginBottom: "10px" }}>
              Unificação realizada com sucesso!
            </p>
          </div>,
        );

        setShowCnesModal(false);
        setSelectedCombo(null);
        setPendingUnification(null);
        buscarCidadao();
        setSelecionados([]);
        setPrincipal(null);
      } catch (error) {
        MySwal.close();

        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Erro ao realizar unificação.";

        console.error("Erro na unificação:", error.response?.data || error);
        await showError("Erro ao unificar cadastros!", errorMessage);
      }
    });
  };

  const executarUnificacaoComCnes = async () => {
    await finalizarUnificacaoComCnes(selectedCombo, pendingUnification);
  };

  // ===============================
  // SELEÇÃO PARA UNIFICAÇÃO
  // ===============================
  const toggleSelecionado = (id) => {
    setSelecionados((prev) =>
      prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id],
    );
  };

  const definirPrincipal = (id) => {
    if (!selecionados.includes(id)) {
      showError(
        "Seleção inválida",
        "O cadastro principal precisa estar marcado na lista.",
      );
      return;
    }
    setPrincipal(id);
  };

  const limparSelecao = () => {
    setSelecionados([]);
    setPrincipal(null);
  };

  const MySwal = withReactContent(Swal);

  const swalConfig = {
    loading: {
      title: "Processando...",
      text: "Aguarde enquanto processamos sua solicitação.",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => MySwal.showLoading(),
    },
    success: {
      icon: "success",
      confirmButtonText: "OK",
      confirmButtonColor: "#3085d6",
    },
    error: {
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#d33",
    },
    warning: {
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#67748e",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    },
  };

  const SWAL_WIDTH_DEFAULT = "520px";
  const SWAL_WIDTH_CONFIRM = "640px";

  const showLoading = (title, text) =>
    MySwal.fire({ ...swalConfig.loading, title, text, width: SWAL_WIDTH_DEFAULT });

  const showSuccess = (title, html) =>
    MySwal.fire({ ...swalConfig.success, title, html, width: SWAL_WIDTH_DEFAULT });

  const showError = (title, text) =>
    MySwal.fire({ ...swalConfig.error, title, text, width: SWAL_WIDTH_DEFAULT });

  const showWarning = (title, html) =>
    MySwal.fire({ ...swalConfig.warning, title, html, width: SWAL_WIDTH_CONFIRM });

  // ===============================
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Unificação de cadastros</h4>
          </div>
        </div>

        {/* FILTROS */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-md-3">
                <label className="form-label">ID do Paciente</label>
                <input
                  className="form-control"
                  value={filtros.id}
                  onChange={(e) =>
                    setFiltros({ ...filtros, id: e.target.value })
                  }
                />
              </div>
              <div className="col-md-9">
                <label className="form-label">Nome/CPF</label>
                <input
                  className="form-control"
                  value={filtros.nomeCpfCns}
                  onChange={(e) =>
                    setFiltros({
                      ...filtros,
                      nomeCpfCns: e.target.value.toUpperCase(),
                    })
                  }
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">Data de nascimento</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtros.dataNascimento || ""}
                  onChange={(e) =>
                    setFiltros({
                      ...filtros,
                      dataNascimento: e.target.value,
                    })
                  }
                />
              </div>

              <div className="col-md-5">
                <label className="form-label">Nome da mãe</label>
                <input
                  className="form-control"
                  value={filtros.nomeMae}
                  onChange={(e) =>
                    setFiltros({
                      ...filtros,
                      nomeMae: e.target.value.toUpperCase(),
                    })
                  }
                />
              </div>

              <div className="col-md-4">
                <label className="form-label">Cidade</label>
                <Select
                  classNamePrefix="react-select"
                  placeholder="Selecione uma cidade..."
                  options={cidades}
                  value={cidadeSelecionada}
                  isDisabled={!!cidadeUsuario}
                  onChange={(selected) => {
                    setCidadeSelecionada(selected);
                    setFiltros({
                      ...filtros,
                      codigoCidade: selected ? Number(selected.value) : null,
                    });
                  }}
                  isClearable
                />
              </div>

              <div className="col-12">
                <div className="row g-2 justify-content-md-end">
                  <div className="col-12 col-md-auto">
                    <button
                      className="btn btn-secondary w-100"
                      onClick={limparBusca}
                    >
                      <i className="feather-x me-2" />
                      Limpar busca
                    </button>
                  </div>
                  <div className="col-12 col-md-auto">
                    <button
                      className="btn btn-primary w-100"
                      onClick={() => buscarCidadao(filtros)}
                      disabled={loading}
                    >
                      <i className="feather-search me-2" />
                      {loading ? "Buscando..." : "Buscar"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="alert alert-danger" role="alert">
          <span className="fw-bold">Atenção!</span> Selecione como{" "}
          <span className="fw-bold">PRINCIPAL</span> o registro mais completo e
          correto.
          <p>
            Em caso de Unidades de Saúde diferentes, na próxima tela escolha a
            UBS responsável pelos exames de rastreamento.
          </p>
        </div>

        {/* RESULTADOS */}
        <div className="card">
          <div className="card-body">
            {pacientes.map((p) => {
              const temExameMama = !!p.ultimoExameMama;
              const temExameColo = !!p.ultimoExameColo;
              const temDoisExames = temExameMama && temExameColo;
              const classeExame = temDoisExames ? "col-md-3" : "col-md-6";

              return (
                <div key={p.id} className="border rounded p-3 mb-3">
                  <div className="row align-items-start">
                    {/* CHECKBOX */}
                    <div className="col-auto">
                      <input
                        type="checkbox"
                        className="form-check-input mt-1"
                        checked={selecionados.includes(p.id)}
                        onChange={() => toggleSelecionado(p.id)}
                      />
                    </div>

                    {/* DADOS */}
                    <div className="col">
                      <strong>{p.nome}</strong>

                      <div className="row mt-1">
                        <div className="col-md-3">
                          <div className="text-muted small">
                            CPF: {p.cpf || "Não informado"} | CNS:{" "}
                            {p.cns || "Não informado"}
                          </div>
                          <div className="text-muted small">
                            Data de Nascimento: {formatDate(p.dataNascimento)}
                          </div>
                          <div className="text-muted small">
                            Nome da mãe:{" "}
                            {capitalizarTexto(p.nomeMae) || "Não informado"}
                          </div>
                          <div className="text-muted small">
                            Telefone: {p.telefone || "Não informado"}
                          </div>
                          <div className="text-muted small">
                            Endereço:{" "}
                            {capitalizarTexto(p.Endereco) || "Não informado"}
                          </div>
                          <div className="text-muted small text-truncate">
                            Unidade Responsável: {p.cnes || "Não informado"} -{" "}
                            {capitalizarTexto(p.unidadeResponsavel) ||
                              "Não informado"}
                          </div>
                        </div>

                        {temExameMama && (
                          <div className={classeExame}>
                            <div className="fw-bold text-primary small mb-2">
                              Informações do exame de mama
                            </div>
                            <div className="text-muted small">
                              Tipo de exame:{" "}
                              {capitalizarTexto(
                                p.ultimoExameMama.tipoUltimoExame,
                              ) || "Não informado"}
                            </div>
                            <div className="text-muted small">
                              Data do último exame:{" "}
                              {formatDate(p.ultimoExameMama.dataUltimoExame) ||
                                "Não informado"}
                            </div>
                            <div className="text-muted small">
                              Data de liberação do exame:{" "}
                              {formatDate(
                                p.ultimoExameMama.dataLiberacaoUltimoExame,
                              ) || "Não informado"}
                            </div>
                            <div className="text-muted small">
                              Resultado do exame:{" "}
                              {capitalizarTexto(
                                p.ultimoExameMama.resultadoUltimoExame,
                              ) || "Não informado"}
                            </div>
                          </div>
                        )}

                        {temExameColo && (
                          <div className={classeExame}>
                            <div className="fw-bold text-primary small mb-2">
                              Informações do exame de colo
                            </div>
                            <div className="text-muted small">
                              Tipo de exame:{" "}
                              {capitalizarTexto(
                                p.ultimoExameColo.tipoUltimoExame,
                              ) || "Não informado"}
                            </div>
                            <div className="text-muted small">
                              Data do último exame:{" "}
                              {formatDate(p.ultimoExameColo.dataUltimoExame) ||
                                "Não informado"}
                            </div>
                            <div className="text-muted small">
                              Data de liberação do exame:{" "}
                              {formatDate(
                                p.ultimoExameColo.dataLiberacaoUltimoExame,
                              ) || "Não informado"}
                            </div>
                            <div className="text-muted small">
                              Resultado do exame:{" "}
                              {capitalizarTexto(
                                p.ultimoExameColo.resultadoUltimoExame,
                              ) || "Não informado"}
                            </div>
                          </div>
                        )}

                        <div className="col-md-3 ms-md-auto">
                          <button
                            className={`btn btn-sm w-100 w-md-auto ${
                              principal === p.id
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => definirPrincipal(p.id)}
                          >
                            <i className="feather-star me-1" />
                            {principal === p.id
                              ? "Principal"
                              : "Definir como principal"}
                          </button>
                          <button
                            className="btn btn-sm btn-outline-secondary w-100 w-md-auto mt-3"
                            type="button"
                            onClick={() => abrirVisualizacao(p)}
                          >
                            <i className="feather-eye me-1" />
                            Visualizar
                          </button>
                        </div>
                      </div>

                      {/* ACCORDION DE PESSOAS UNIFICADAS */}
                      <div className="mt-3">
                        <div
                          className="d-flex align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => toggleAccordion(p.id)}
                        >
                          <i
                            className={`feather-chevron-${accordionAberto[p.id] ? "down" : "right"} me-2`}
                          />
                          <span className="fw-bold text-primary">
                            Pessoas Unificadas:{" "}
                            {p.quantidadePessoasUnificadas || 0}
                          </span>
                          {loadingUnificadas[p.id] && (
                            <div
                              className="spinner-border spinner-border-sm ms-2"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Carregando...
                              </span>
                            </div>
                          )}
                        </div>

                        {/* CONTEÚDO DO ACCORDION */}
                        {accordionAberto[p.id] && (
                          <div className="mt-3 ps-4 border-start border-2">
                            {loadingUnificadas[p.id] ? (
                              <div className="text-center py-3">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Carregando...
                                  </span>
                                </div>
                              </div>
                            ) : pessoasUnificadas[p.id]?.length > 0 ? (
                              <>
                                <div className="row g-2 align-items-center mb-3">
                                  <div className="col-12 col-md">
                                    <span className="text-muted me-2">
                                      {
                                        (pessoasParaDesunificar[p.id] || [])
                                          .length
                                      }{" "}
                                      selecionado(s)
                                    </span>

                                    <div className="d-flex flex-wrap gap-2 mt-2 mt-md-0">
                                      <button
                                        className="btn btn-sm btn-primary"
                                        onClick={() =>
                                          selecionarTodasDesunificar(p.id)
                                        }
                                      >
                                        <i className="feather-check me-2" />
                                        Selecionar todos
                                      </button>

                                      <button
                                        className="btn btn-sm btn-secondary"
                                        onClick={() =>
                                          limparSelecaoDesunificar(p.id)
                                        }
                                        disabled={
                                          (pessoasParaDesunificar[p.id] || [])
                                            .length === 0
                                        }
                                      >
                                        <i className="feather-x me-2" />
                                        Limpar seleção
                                      </button>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-auto">
                                    <button
                                      className="btn btn-sm btn-danger w-100"
                                      onClick={() => abrirModalMotivo(p.id)}
                                      disabled={
                                        (pessoasParaDesunificar[p.id] || [])
                                          .length === 0
                                      }
                                    >
                                      <i className="feather-x me-1" />
                                      Desunificar selecionados
                                    </button>
                                  </div>
                                </div>

                                <div className="table-responsive">
                                  <table className="table table-sm table-bordered table-hover">
                                    <thead className="thead-light">
                                      <tr>
                                        <th style={{ width: "40px" }}>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={
                                              pessoasUnificadas[p.id]?.length >
                                                0 &&
                                              (
                                                pessoasParaDesunificar[p.id] ||
                                                []
                                              ).length ===
                                                pessoasUnificadas[p.id]?.length
                                            }
                                            onChange={() =>
                                              selecionarTodasDesunificar(p.id)
                                            }
                                          />
                                        </th>
                                        <th>Nome</th>
                                        <th>CPF</th>
                                        <th>CNS</th>
                                        <th>Data Nascimento</th>
                                        <th>Sexo</th>
                                        <th>Nome da Mãe</th>
                                        <th>Unidade Responsável</th>
                                        <th>CNES</th>
                                        <th>Unificada em</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {pessoasUnificadas[p.id].map(
                                        (unificada) => (
                                          <tr key={unificada.unificacaoId}>
                                            <td>
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={(
                                                  pessoasParaDesunificar[
                                                    p.id
                                                  ] || []
                                                ).includes(unificada.pessoaId)}
                                                onChange={() =>
                                                  toggleSelecionadoDesunificar(
                                                    p.id,
                                                    unificada.pessoaId,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td>
                                              {capitalizarTexto(unificada.nome)}
                                            </td>
                                            <td>{unificada.cpf || "-"}</td>
                                            <td>{unificada.cns || "-"}</td>
                                            <td>
                                              {formatDate(
                                                unificada.dataNascimento,
                                              )}
                                            </td>
                                            <td>
                                              {capitalizarTexto(
                                                unificada.sexo,
                                              ) || "-"}
                                            </td>
                                            <td>
                                              {capitalizarTexto(
                                                unificada.nomeMae,
                                              ) || "-"}
                                            </td>
                                            <td>
                                              {capitalizarTexto(
                                                unificada.unidadeResponsavel,
                                              ) || "-"}
                                            </td>
                                            <td>{unificada.cnes || "-"}</td>
                                            <td>
                                              {formatDate(
                                                unificada.unificadaEm,
                                              )}
                                            </td>
                                          </tr>
                                        ),
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </>
                            ) : (
                              <p className="text-muted mb-0">
                                Nenhuma pessoa unificada encontrada.
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {pacientes.length === 0 && !loading && (
              <div className="text-center py-5">
                <p className="text-muted">Nenhum cidadão encontrado.</p>
              </div>
            )}

            <div className="row align-items-center mt-3 g-2">
              <div className="col-12 col-md">
                <div className="text-muted small">
                  {selecionados.length} registro(s) selecionado(s) para
                  unificação
                </div>
              </div>

              <div className="col-12 col-md-auto">
                <button
                  className="btn btn-secondary w-100"
                  onClick={limparSelecao}
                  disabled={selecionados.length === 0}
                >
                  <i className="feather-x me-2" />
                  Limpar seleção
                </button>
              </div>

              <div className="col-12 col-md-auto">
                <button
                  className="btn btn-primary w-100"
                  disabled={selecionados.length < 2 || !principal}
                  onClick={abrirModalCnes}
                >
                  <i className="feather-link me-2" />
                  Unificar cadastros
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MODAL DE SELEÇÃO DE CNES + ORGANOGRAMA (SELECT ÚNICO) */}
      {showCnesModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content modal-content-custom">
              <div className="modal-header">
                <h5 className="modal-title">Selecionar Unidade</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowCnesModal(false);
                    setPendingUnification(null);
                  }}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info">
                  <i className="feather-info me-2"></i>
                  Selecione a Unidade de Saúde responsável pelos exames de
                  rastreamento.
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="comboSelect" className="form-label fw-bold">
                    Unidade de Saúde <span className="text-danger">*</span>
                  </label>
                  <Select
                    id="comboSelect"
                    classNamePrefix="react-select"
                    placeholder={
                      loadingCombo
                        ? "Carregando opções..."
                        : "Selecione uma unidade com organograma..."
                    }
                    options={comboOptions}
                    value={selectedCombo}
                    onChange={setSelectedCombo}
                    isDisabled={loadingCombo || comboOptions.length === 0}
                    isLoading={loadingCombo}
                    isClearable
                  />
                  {comboOptions.length === 0 && !loadingCombo && (
                    <div className="text-warning small mt-1">
                      Nenhuma unidade de saúde com organograma disponível para
                      os pacientes selecionados.
                    </div>
                  )}
                </div>

                <div className="alert alert-secondary mt-3">
                  <small className="text-muted">
                    <i className="feather-info me-1"></i>A usuária será alocada
                    na Unidade de Saúde selecionada após a unificação
                  </small>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowCnesModal(false);
                    setPendingUnification(null);
                  }}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={executarUnificacaoComCnes}
                  disabled={!selectedCombo || loadingCombo}
                >
                  <i className="feather-check me-1"></i>
                  Confirmar Unificação
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DE MOTIVO PARA DESUNIFICAÇÃO */}
      {showMotivoModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content modal-content-custom">
              <div className="modal-header">
                <h5 className="modal-title">Motivo da Desunificação</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowMotivoModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="motivoReversao">
                    Informe o motivo da desunificação:
                  </label>
                  <textarea
                    id="motivoReversao"
                    className="form-control mt-2"
                    rows="4"
                    value={motivoReversao}
                    onChange={(e) => setMotivoReversao(e.target.value)}
                    placeholder="Descreva o motivo da desunificação..."
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowMotivoModal(false)}
                >
                  <i className="feather-x me-1"></i>
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={desunificar}
                  disabled={!motivoReversao.trim()}
                >
                  <i className="feather-check me-1"></i>
                  Confirmar Desunificação
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AgruparModal />
      <EditRastreamento
        pacienteSelecionado={pacienteSelecionado}
        onClose={() => setPacienteSelecionado(null)}
      />
    </div>
  );
};

export default UnificacaoCadastros;
